import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tacho-empty-state',
  templateUrl: './tacho-empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./tacho-empty-state.component.scss'],
})
export class TachoEmptyStateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
